// extracted by mini-css-extract-plugin
export default {"usermenu__container":"UserMenu_usermenu__container__fDTLH","usermenu__img":"UserMenu_usermenu__img__LBtus"};